<template>
  <div>
    <v-card-text>
      <br />
      <h2 class="title mb-2">{{ stringValues.chooseBin[currentLanguage.language] }}</h2>

      <v-chip-group
        v-model="accessUserBINsSelection"
        column
        active-class="primary--text"
      >
        <v-chip
          filter
          outlined
          v-for="accessUserBIN in accessUserBINs"
          :key="accessUserBIN.bin"
        >
          {{ accessUserBIN.bin }}
          {{ accessUserBIN.companyBIN.description }}
        </v-chip>
      </v-chip-group>
    </v-card-text>

    <!-- Discounts -->
    <v-card-text v-if="accessUserBINsSelection > -1">
      <span class="text-h6 mr-10">{{ stringValues.discounts[currentLanguage.language] }}</span>
      <span class="subheading">
        <v-icon color="warning">mdi-alert-circle-outline</v-icon>{{ stringValues.discountsInfo[currentLanguage.language] }},</span
      >
      {{ stringValues.or[currentLanguage.language] }}
      <v-menu
        v-model="createDiscountMenu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" x-small>{{ stringValues.createNew[currentLanguage.language] }}</v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-sheet elevation="2" class="pa-2 mr-1 mb-1">
                  <v-subheader
                    ><v-autocomplete
                      :label="stringValues.chooseSupplier[currentLanguage.language]"
                      item-text="name"
                      item-value="id"
                      :items="filials"
                      persistent-hint
                      return-object
                      clearable
                      v-model="discount.filial"
                      :error-messages="modelState['Filial']"
                    ></v-autocomplete
                  ></v-subheader>
                  <v-text-field
                    :label="stringValues.discount[currentLanguage.language]"
                    :value="discount.userDiscount"
                    prefix="%"
                    :rules="discountRules"
                    required
                    v-model="discount.userDiscount"
                    :error-messages="modelState['UserDiscount']"
                  ></v-text-field>
                </v-sheet>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              small
              :loading="loading"
              text
              @click="createDiscountMenu = false"
              >{{ stringValues.cancel[currentLanguage.language] }}</v-btn
            >
            <v-btn small :loading="loading" text @click="CreateDiscount()"
              >Добавьте</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-menu>

      <v-row class="pt-4">
        <v-sheet
          elevation="4"
          class="pa-2 mr-1 mb-1"
          v-for="(discount, index) in discounts.filter(
            (x) =>
              x.bin == accessUserBINs[accessUserBINsSelection].bin &&
              x.isContract == false
          )"
          :key="index"
        >
          <v-subheader
            >{{ discount.filial.name }}
            <v-btn
              class="ml-2"
              fab
              x-small
              color="warning"
              @click="DeleteDiscount(discount)"
              :disabled="discount.isContract"
            >
              <v-icon> mdi-delete </v-icon>
            </v-btn></v-subheader
          >

          <v-text-field
            :label="stringValues.discount[currentLanguage.language]"
            :value="discount.userDiscount"
            prefix="%"
            readonly
          ></v-text-field>
          <span v-if="discount.isContract">
            Наименование договора:
            <br />
            <code> {{ discount.distributorContractName }} </code>
          </span>
        </v-sheet>
      </v-row>
    </v-card-text>

    <!-- Contracts -->
    <v-card-text v-if="accessUserBINsSelection > -1">
      <span class="text-h6 mr-10">{{ stringValues.contracts[currentLanguage.language] }}</span>
      <span class="subheading">
        <v-icon color="warning">mdi-alert-circle-outline</v-icon> </span
      >
      
      <v-menu
        v-model="createContractMenu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" x-small>{{ stringValues.uploadNewConract[currentLanguage.language] }}</v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-sheet elevation="2" class="pa-2 mr-1 mb-1">
                  <v-subheader
                    ><v-autocomplete
                      :label="stringValues.chooseSupplier[currentLanguage.language]"
                      item-text="name"
                      item-value="id"
                      :items="contractFilials"
                      persistent-hint
                      return-object
                      clearable
                      v-model="discount.filial"
                      :error-messages="modelState['Filial']"
                    ></v-autocomplete
                  ></v-subheader>
                </v-sheet>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              small
              text
              :loading="loading"
              @click="createContractMenu = false"
              >{{ stringValues.cancel[currentLanguage.language] }}</v-btn
            >
            <v-btn small text :loading="loading" @click="CreateContract()"
              >Выгрузить</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-menu>
  
      <!-- Договоры сгруппированы по поставщику (филиалу): заголовок группы + удаление всей группы -->
      <div
        v-for="group in contractGroups"
        :key="group.filial.id"
        class="mt-6"
      >
        <div class="d-flex align-center flex-wrap">
          <span class="subtitle-1 font-weight-medium mr-2">{{ group.filial.name }}</span>
          <v-chip x-small class="mr-4">{{ group.contracts.length }}</v-chip>
          <v-btn
            x-small
            outlined
            color="warning"
            :loading="deletingFilialId == group.filial.id"
            :disabled="deletingFilialId != null"
            @click="OpenDeleteFilialContracts(group)"
          >
            <v-icon left x-small>mdi-delete-sweep</v-icon>
            {{ stringValues.deleteAllContracts[currentLanguage.language] }} {{ group.filial.name }}
          </v-btn>
        </div>
        <v-divider class="mt-2"></v-divider>

        <v-row class="pt-4 mx-0">
          <v-sheet
            elevation="4"
            class="pa-2 mr-1 mb-1"
            v-for="discount in group.contracts"
            :key="discount.id"
          >
            <v-subheader
              >{{ discount.filial.name }}
              <v-btn
                class="ml-2"
                fab
                x-small
                color="warning"
                @click="DeleteDiscount(discount)"
              >
                <v-icon> mdi-delete </v-icon>
              </v-btn></v-subheader
            >

            <v-text-field
              :label="stringValues.discount[currentLanguage.language]"
              :value="discount.userDiscount"
              prefix="%"
              readonly
            ></v-text-field>
            <span v-if="discount.isContract">
              Наименование договора:
              <br />
              <code> {{ discount.distributorContractName }} </code>
            </span>
            <v-checkbox
              dense
              :disabled="discount.working"
              v-model="discount.working"
              :label="`Рабочий договор`"
              @click="SetWorkingContract(discount)"
            ></v-checkbox>
          </v-sheet>
        </v-row>
      </div>
    </v-card-text>

    <v-dialog v-model="deleteFilialContractsDialog" max-width="480">
      <v-card v-if="deleteFilialContractsGroup">
        <v-card-title class="text-h6" style="word-break: normal">
          {{ stringValues.deleteAllContracts[currentLanguage.language] }}
          {{ deleteFilialContractsGroup.filial.name }}?
        </v-card-title>
        <v-card-text>
          {{ stringValues.deleteAllContractsConfirm[currentLanguage.language] }}
          <div class="mt-2">
            {{ stringValues.contracts[currentLanguage.language] }}:
            <b>{{ deleteFilialContractsGroup.contracts.length }}</b>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text @click="deleteFilialContractsDialog = false">{{
            stringValues.cancel[currentLanguage.language]
          }}</v-btn>
          <v-btn small text color="warning" @click="DeleteFilialContracts()">{{
            stringValues.deleteAllContracts[currentLanguage.language]
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    discountRules: [(v) => !!v || "Скидка обязательно"],
    modelState: {},
    discounts: [],
    accessUserBINs: [],
    accessUserBINsSelection: 0,
    createDiscountMenu: false,
    createContractMenu: false,
    discount: {
      filial: null,
      userDiscount: null,
      bin: null,
    },
    // Доступные пользователю филиалы (Distributor/GetFilialsByContext) — селект «Создайте новое».
    filials: [],
    // Доступные + со способностью CONTRACT (Distributor/GetContractFilialsByContextAsync) — селект «Выгрузить новый договор».
    contractFilials: [],
    filial: {},
    loading: false,
    deleteFilialContractsDialog: false,
    deleteFilialContractsGroup: null,
    deletingFilialId: null,
  }),
  methods: {
    GetDiscounts() {
      this.$store
        .dispatch("DISCOUNTS")
        .then((response) => {
          this.discounts = response;
        })
        .catch(() => {});
    },
    GetAccessUserBINs() {
      this.$store
        .dispatch("ACCESS_USER_BINS_BY_CONTEXT")
        .then((response) => {
          this.accessUserBINs = response;

          this.accessUserBINsSelection = response.indexOf(
            response.find((x) => x.working == true)
          );
        })
        .catch(() => {});
    },
    // Раньше брался общий справочник FILIALS из стора (все 300+ филиалов всех городов, и список
    // мог остаться от другой страницы/сессии). Теперь — только доступные пользователю филиалы,
    // запрос при каждом открытии страницы, как на странице «Прайсы».
    GetDistributors() {
      this.$store
        .dispatch("FILIALS_BY_CONTEXT")
        .then(() => {
          this.filials = [...this.$store.getters.FILIALS].sort((a, b) =>
            a.name.localeCompare(b.name)
          );
        })
        .catch(() => {});

      this.$store
        .dispatch("CONTRACT_FILIALS_BY_CONTEXT")
        .then((response) => {
          this.contractFilials = response;
        })
        .catch(() => {});
    },
    CreateDiscount() {
      this.loading = true;
      this.modelState = {};
      this.discount.bin = this.accessUserBINs[this.accessUserBINsSelection]?.bin;

      this.$store
        .dispatch("CREATE_DISCOUNT", this.discount)
        .then((response) => {
          this.discounts.push(response);
          this.createDiscountMenu = false;
          this.loading = false;
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.modelState = error.response.data.errors;
          }
          this.loading = false;
        });
    },
    CreateContract() {
      this.loading = true;
      this.modelState = {};
      let payload = {
        filialId: this.discount.filial.id,
        accessUserBIN: (this.discount.bin = this.accessUserBINs[
          this.accessUserBINsSelection
        ]?.bin),
      };

      this.$store
        .dispatch("UNLOAD_CONTRACTS", payload)
        .then(() => {
          this.createContractMenu = false;
          this.loading = false;
          this.GetDiscounts();
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.modelState = error.response.data.errors;
          }
          this.loading = false;
        });
    },
    SetWorkingContract(discount) {
      this.loading = true;
      this.modelState = {};

      this.$store
        .dispatch("SET_WORKING_CONTRACT", discount)
        .then(() => {
          this.loading = false;
          this.GetDiscounts();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    DeleteDiscount(discount) {
      discount.bin = this.accessUserBINs[this.accessUserBINsSelection]?.bin;
      this.$store
        .dispatch("DELETE_DISCOUNT", discount)
        .then(() => {
          this.GetDiscounts();
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    OpenDeleteFilialContracts(group) {
      this.deleteFilialContractsGroup = group;
      this.deleteFilialContractsDialog = true;
    },
    DeleteFilialContracts() {
      let filialId = this.deleteFilialContractsGroup.filial.id;
      let payload = {
        filialId,
        bin: this.accessUserBINs[this.accessUserBINsSelection]?.bin,
      };

      this.deleteFilialContractsDialog = false;
      this.deletingFilialId = filialId;

      this.$store
        .dispatch("DELETE_FILIAL_CONTRACTS", payload)
        .then(() => {
          let Success = {
            text: this.stringValues.contractsDeleted[this.currentLanguage.language],
            timeout: 5000,
            color: "success",
            show: true,
          };
          this.$store.commit("SET_SNACKBAR", Success);
          this.GetDiscounts();
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.deletingFilialId = null;
        });
    },
    UpdateWorkingAccessUserBIN(setAccessUserBIN) {
      this.$store
        .dispatch("UPDATE_WORKING_ACCESS_USER_BIN", setAccessUserBIN?.bin)
        .then(() => {
          this.accessUserBINs.forEach(function (accessUserBIN) {
            if (accessUserBIN.bin == setAccessUserBIN.bin)
              accessUserBIN.working = true;
            else accessUserBIN.working = false;
          });
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
  },
  mounted() {
    this.GetAccessUserBINs();
    this.GetDiscounts();
    this.GetDistributors();
  },
  computed: {
    stringValues: {
      get() {
        return this.$store.getters.STRING_VALUES;
      },
    },
    currentLanguage: {
      get() {
        return this.$store.getters.CURRENT_LANG;
      }
    },
    contractGroups() {
      let bin = this.accessUserBINs[this.accessUserBINsSelection]?.bin;
      let groups = [];

      this.discounts
        .filter((x) => x.bin == bin && x.isContract == true)
        .forEach((contract) => {
          let group = groups.find((x) => x.filial.id == contract.filial.id);
          if (group == undefined) {
            group = { filial: contract.filial, contracts: [] };
            groups.push(group);
          }
          group.contracts.push(contract);
        });

      return groups.sort((a, b) => a.filial.name.localeCompare(b.filial.name));
    },
    accessUserBINWorking: {
      get: function () {
        return this.accessUserBINs.find((x) => x.working == true);
      },
      set: function (setAccessUserBIN) {
        this.UpdateWorkingAccessUserBIN(setAccessUserBIN);
      },
    },
    accessUserBINWorkingDescription: {
      get: function () {
        return this.accessUserBINWorking?.companyBIN?.description;
      },
    },
  },
};
</script>

<style>
</style>